import { render } from "./TheFeaturesTabs.vue?vue&type=template&id=6d45db9c"
import script from "./TheFeaturesTabs.vue?vue&type=script&lang=js"
export * from "./TheFeaturesTabs.vue?vue&type=script&lang=js"
script.render = render

export default script